<template>
  <div class="szw-row szw-p-2 szw-text-xs szw-w-full szw-border-bottom">
    <div :class="['szw-row szw-gap-1 szw-overflow-hidden szw-mr-auto', !props.isSmallWidgetContainerSize ? 'szw-max-w-40 szw-w-full' : 'szw-w-fit']">
      <!-- competition marker -->
      <span class="szw-h-5 szw-w-0.75 szw-rounded-md szw-bg-section-static szw-animate-pulse" />

      <!-- row rank -->
      <span class="szw-w-5 szw-h-4 szw-text-center szw-rounded szw-bg-section-static szw-animate-pulse" />

      <!-- row logo -->
      <div class="szw-w-5 szw-h-5 szw-rounded-full szw-bg-section-static szw-animate-pulse" />

      <!-- row name -->
      <span :class="['szw-h-4 szw-bg-section-static szw-animate-pulse szw-rounded', !props.isSmallWidgetContainerSize ? 'szw-w-24' : 'szw-w-6']" />
    </div>

    <!-- heading cell -->
    <span v-for="heading of 5" class="szw-w-7 szw-h-4 szw-bg-section-static szw-animate-pulse szw-rounded first:ml-0 szw-ml-0.5" :key="heading" />
  </div>
</template>
<script setup>
const props = defineProps({
  isSmallWidgetContainerSize: {
    type: Boolean,
    default: () => false
  }
})
</script>
